import React, {useContext} from 'react';
import {Keyboard, Platform, ScrollView, View} from "react-native";
import { StatusBar } from "@common/systemBars/StatusBar";
import {apiIdle, apiRequest} from "@data/redux/actions/api";
import {theme} from "@common/theme/theme";
import {connect} from "react-redux";
import TextM from "@common/components/text/TextM";
import TitleM from "@common/components/text/TitleM";
import {useForm} from "react-hook-form";
import TextInputM from "@common/components/input/TextInputM";
import FilledButtonM from "@common/components/button/FilledButtonM";
import ErrorTextM from "@common/components/text/ErrorTextM";
import {validation} from "@data/utility/validation";
import {schoolsService} from "@data/services/schoolsService";
import {congratsTypes} from "@common/screens/CongratsScreen";
import {useApiStatus} from "@common/hooks/useApiStatus";
import moment from "moment";
import {DimensionsContext, IS_WEB} from "@common/utils/mobileUtils";
import {putCongrats} from "@data/redux/actions/navigation";


const JoinSchoolScreen = (props) => {

    // ** Component props
    const {navigation} = props

    const {control, handleSubmit, formState: {errors, dirtyFields}, register} = useForm({
        defaultValues: {
            code: ''
        }
    })

    const onSubmit = data => {
        if (props.joinSchoolRequest) return
        Keyboard.dismiss()
        // console.log(data)
        props.apiRequest(schoolsService.joinSchool, {}, {...data})
    }

    useApiStatus(
        schoolsService.joinSchool, // api service
        null, // success message on toast (string or null)
        false, // error message on toast (true) or keep it in redux state (false)
        (successData) => {

            // console.log("success data", successData)

            const congrats = [{
                congratsType: congratsTypes.GENERIC,
                congratsData: {
                    title: "Bravo !",
                    text: "Tu as rejoint l'école " + successData?.schools?.[successData?.schools?.length - 1]?.name + (moment().isBefore(successData?.trial_ends_at) ? ", et ton essai est prolongé jusqu'au " + moment(successData?.trial_ends_at).format("DD/MM/YYYY") : "")
                }
            }]

            props.putCongrats(congrats)
            navigation.replace("congrats")
        } // success callback
    )
    const dimensions = useContext(DimensionsContext)


    return (
        <View style={{
            flex: 1,
            // backgroundColor: theme.colors.white,
            alignItems: 'center',
            alignSelf: "center",
            width: dimensions?.width
            // justifyContent: 'center'
        }}>

            <ScrollView contentContainerStyle={{
                // alignItems: 'center'
                paddingTop: 20,
                paddingHorizontal: 15
            }}>

                <TitleM fontWeight="ExtraBold"
                        style={{
                            marginBottom: 10
                        }}>À propos</TitleM>
                <TextM style={{
                    marginBottom: 40,
                    // textAlign: "justify",
                    lineHeight: 28
                }}
                       fontSize={16}
                       wrap>
                    Partage ton activité avec tes professeurs en utilisant le code de ton école. Cela leur permettra
                    d'accéder à tes statistiques, et bien plus encore (à venir).
                </TextM>

                <TitleM fontWeight="ExtraBold"
                        style={{
                            marginBottom: 10
                        }}>Code d'école</TitleM>

                <TextInputM {...register("code", {...validation.required()})}
                            placeholder="Exemple : ABCDEF"
                            control={control}
                            errors={errors}
                            autoCapitalize="characters"
                    // maxLength={6}
                />
                {props.user.schools?.length > 0 && <TextM style={{
                    marginTop: 10
                }}
                                                          color={theme.colors.light}
                                                          fontSize={16}
                                                          wrap>
                    Tes écoles
                    : {props.user.schools?.map((x) => x?.name)?.join(",")}
                </TextM>}
                <ErrorTextM errorData={props.joinSchoolError}/>
                <FilledButtonM style={{
                    alignSelf: Platform.OS !== 'web' ? 'stretch' : 'center',
                    marginTop: 20
                }}
                               loading={props.joinSchoolRequest}
                               onPress={handleSubmit(onSubmit)}
                               label="Rejoindre l'école"/>

                {IS_WEB && <FilledButtonM mode={"text"}
                                          icon={"chevron-left"}
                                          color={theme.colors.link}
                                          style={{marginTop: 60}}
                                          onPress={() => {
                                              if (navigation.canGoBack())
                                                  navigation.goBack()
                                              else
                                                  navigation.replace("account")
                                          }}
                                          label={"Retour"}/>}
                <View style={{
                    height: 200
                }}/>
            </ScrollView>

            <StatusBar style="dark" backgroundColor={theme.colors.white} translucent={false}/>
        </View>
    );
}
const mapStateToProps = state => {
    return {
        joinSchoolRequest: state.api.joinSchool?.request,
        joinSchoolError: state.api.joinSchool?.error,

        user: state.data.currentUser?.object
    }
}

const mapDispatchToProps =
    {
        apiRequest,
        apiIdle,
        putCongrats,

    }

export default connect(mapStateToProps, mapDispatchToProps)(JoinSchoolScreen)